/* eslint-disable prefer-rest-params */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable camelcase */
import React, { useCallback, useState, useEffect } from 'react';
import CurrencyInput from 'react-currency-input';
import { currency } from '@utils';
import debounce from 'lodash.debounce';
import { ValidateError } from '../ErrorMessage';
import './styles.css';

export const CurrencyTextInput = ({
  value,
  defaultValue,
  max,
  min,
  onChange,
  label,
  height,
  fontSize,
  disabled,
  id,
  className,
  field,
  form,
  ...otherProps
}) => {
  const [error, setError] = useState(false);
  // Fix autofocus issues with CurrencyInput
  // on iOS it will still auto focus even if autoFocus=false
  // see https://github.com/jsillitoe/react-currency-input/issues/90
  const componentDidMount_super = CurrencyInput.prototype.componentDidMount;
  CurrencyInput.prototype.componentDidMount = function () {
    if (!this.props.autoFocus) {
      const setSelectionRange_super = this.theInput.setSelectionRange;
      this.theInput.setSelectionRange = () => {};
      componentDidMount_super.call(this, ...arguments);
      this.theInput.setSelectionRange = setSelectionRange_super;
    } else {
      componentDidMount_super.call(this, ...arguments);
    }
  };
  const componentDidUpdate_super = CurrencyInput.prototype.componentDidUpdate;
  CurrencyInput.prototype.componentDidUpdate = function () {
    if (!this.props.autoFocus) {
      const setSelectionRange_super = this.theInput.setSelectionRange;
      this.theInput.setSelectionRange = () => {};
      componentDidUpdate_super.call(this, ...arguments);
      this.theInput.setSelectionRange = setSelectionRange_super;
    } else {
      componentDidMount_super.call(this, ...arguments);
    }
  };

  const debouncedSave = useCallback(
    debounce((nextValue) => setError(nextValue), 2000),
    []
  );

  const handleError = (val) => {
    debouncedSave(val);
  };

  useEffect(() => {
    if (error && disabled) {
      setError(false);
    }
  }, [disabled, error]);

  return (
    <div className={className}>
      {label ? (
        <label
          className={`label ${disabled ? 'disabled' : ''} ${
            form
              ? form.errors[field.name] && form.touched[field.name]
                ? 'error'
                : ''
              : ''
          }`}
          htmlFor={id}
        >
          {label}
        </label>
      ) : (
        ''
      )}
      {field ? (
        <div className={`text-input-wrapper ${label ? '' : 'no-label'}`}>
          <CurrencyInput
            {...otherProps}
            className={`text-input ${fontSize} ${
              form
                ? form.errors[field.name] && form.touched[field.name]
                  ? 'error'
                  : ''
                : ''
            }`}
            style={{ height }}
            prefix="R$"
            autoFocus={false}
            precision={2}
            allowEmpty
            decimalSeparator=","
            thousandSeparator="."
            value={field.value}
            onChange={(val, formatted) =>
              form.setFieldValue(field.name, formatted)
            }
            disabled={disabled}
          />
          {min && max && (
            <ValidateError>{form.errors[field.name]}</ValidateError>
          )}
          {!form.isValid
            ? form.touched[field.name] &&
              form.errors[field.name] && (
                <ValidateError>{form.errors[field.name]}</ValidateError>
              )
            : ''}
        </div>
      ) : (
        <div className="text-input-wrapper no-label d-flex gap-3 align-items-center">
          <CurrencyInput
            {...otherProps}
            className={`text-input max-400 ${fontSize}`}
            style={{ height }}
            prefix="R$"
            value={value || defaultValue}
            precision={2}
            autoFocus={false}
            allowEmpty
            decimalSeparator=","
            thousandSeparator="."
            onChange={(val, formatted) => {
              if (min && max) {
                onChange(formatted, val);
                handleError(!(formatted >= min && formatted <= max));
              } else {
                onChange(formatted, val);
              }
            }}
            disabled={disabled}
          />

          {error && min && max && (
            <p className="fw-bold text-error">
              Favor insira um valor de {currency(min)} até {currency(max)}
            </p>
          )}
        </div>
      )}
    </div>
  );
};
